import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Dashboard } from 'types/dashboard';

import { migrateDataWidgetFilters } from '../components/DataWidgetFiltersInput/migrate';
import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseDashboardOptions = UseQueryOptions<Dashboard, APIError>;

export function useDashboard(
  dashboardId: Dashboard['id'] | undefined,
  { enabled, ...options }: UseDashboardOptions = {}
) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    ['dashboard', dashboardId, applicationID],
    async () => {
      if (!dashboardId) {
        return Promise.reject('No dashboard id provided.');
      }

      const { data: dashboard } = await client.get<Dashboard>(
        `/internal/apps/${applicationID}/dashboards/${dashboardId}`
      );

      return migrateDataWidgetFilters(dashboard);
    },
    {
      ...options,
      enabled:
        enabled !== undefined
          ? enabled && Boolean(dashboardId)
          : Boolean(dashboardId),
    }
  );
}
